module.exports = __webpack_public_path__ + "c8e167313a9c0a1a127ae39f472ef4c2.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-main-320.webp.png
// module id = 325
// module chunks = 0